var storage = {
  /* key 保存键
   * value 保存内容 localSorage 不能保存 Object 对象 需要使用 stringify 进行转换
   * expired 失效时间 定义 单位 分钟
   */
  set(key, value, expired = 60 * 24 * 30) {

    /*定义 source 临时 对象 临时存储 key value 赋值后 加入到 localStorage */
    let source = { key: key, value: value };

    /*now 获取当前时间 */
    const now = Date.now();
    /*1 分钟计算 (1000*60)  计算出总失效时间 (1000 * 60 * expired) now + 失效总分钟 算出最大存储时间*/
    source.value = JSON.stringify({ data: value, expired: now + (this.date.minute * expired) });

    localStorage.setItem(source.key, source.value);
  },
  /**
   * (延时策略：如果 delayTime > expired - now 那么 更新延时 expired + delayTime 否则不进行延时)
   * @param {*} key
   * @param {*} delayTime 延期_续时 单位分钟
   * @returns string
   */
  get(key, delayTime) {
    const now = Date.now();

    let source = { key: key, value: null };
    /* 获取 localStorage 存储信息 赋值给 source 对象 */
    source.value = JSON.parse(localStorage.getItem(source.key));

    /* 如果key 有效  判断当前时间 是否超过 失效时间 */
    if (!!source.value) {

      if (now >= source.value.expired) {
        /* 超过失效时间 删除 储存内容  */
        this.remove(source.key);
        return;
      } else {
        /** */
        if (!!delayTime) {
          let { data, expired } = source.value
          if (1000 * 60 * delayTime > Number(expired) - now) {
            let delayData = JSON.stringify({ data: data, expired: expired + (1000 * 60 * delayTime) })
            localStorage.setItem(source.key, delayData)
          }
        }
        return source.value.data;
      }
    }
  },
  /**
   * 删除
   * @param {*} key
   */
  remove(key) {
    localStorage.removeItem(key);
  },
  expiredtime(key) {
    //获取失效时间
    const now = Date.now();

    let source = { key: key, value: null };
    /* 从缓存中取出 信息*/
    source.value = JSON.parse(localStorage.getItem(source.key));

    /* 判断 key 是否失效 */
    if (source.value) {
      /* 获取失效时间 */
      let expired = source.value.expired;
      // source.value.expired = source.value.expired = moment(expired).diff(moment(now), 'seconds');
      source.value.expired = source.value.expired = ((expired - now) / this.date.minute).toFixed()
      return source.value.expired;
    } else {
      return;
    }

  },
  date: {
    seconds: 1000,
    minute: 60 * 1000,
    hour: 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    mounth: 30 * 24 * 60 * 60 * 1000,
    year: 12 * 30 * 24 * 60 * 60 * 1000
  }
}

/*export default  用于导出 函数   类中只能定义一个 其他类通过此对象可调用 该类所有方法*/
export default storage;



// WEBPACK FOOTER //
// ./src/utils/storage.js